import {Box, Text} from '@chakra-ui/react'
import {useTranslate} from '@tolgee/react'
import {LuCircleAlert} from 'react-icons/lu'
import {formatGfr} from '@/modules/patients/functions'
import {gfrLevel} from './dialogs/calculate-gfr'

const gfrColors = (level: string) => {
  switch (level) {
    case 'normal':
      return 'green'
    case 'implausible':
      return 'red'
    case 'moderate_severe':
      return 'red'
    case 'kidney_failure':
      return 'red'
    default:
      return 'orange'
  }
}

export function GFRAlert({gfrValue}: {gfrValue?: number}) {
  const {t} = useTranslate('common')
  const color = gfrValue ? gfrColors(gfrLevel(gfrValue)) : 'blue'
  return (
    <Box
      bgColor={`${color}.subtle`}
      display={'flex'}
      p="4"
      borderRadius={'md'}
      gap="3"
      width={'100%'}
      colorPalette={`${color}.fg`}
    >
      {gfrValue ? (
        <Box display={'flex'} flexDirection={'column'} gap={'3'} width={'100%'} pt="2">
          <Text fontSize={'3xl'} fontWeight={'bold'} color={`${color}.fg`}>
            {formatGfr(gfrValue)} {t('ml_min')}
          </Text>

          <Text fontWeight={'medium'} color={`${color}.fg`}>
            {t(`gfr.${gfrLevel(gfrValue)}`)}
          </Text>
        </Box>
      ) : (
        <>
          <Box colorPalette={'orange.fg'}>
            <LuCircleAlert size="18" color="#173da6" />
          </Box>
          <Box>
            <Text fontWeight={'medium'} color="blue.fg">
              {t('gfr.enter_data')}
            </Text>
          </Box>
        </>
      )}
    </Box>
  )
}
